import { useState } from "react";
import styled from "styled-components";
import { ReactComponent as IconImageHover } from "../Images/icon_image_hover.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import { ReactComponent as IconPlus } from "../Images/icon_plus.svg";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const AddImage = ({
  title,
  isRequired = false,
  noticeText,
  handleClickEx,
  handleClickUpload,
  previewImg,
  page = "",
  showExample = true,
  readOnly = false,
}) => {
  let previewImgUrl;
  if (typeof previewImg === "string") {
    previewImgUrl =
      previewImg.startsWith("data:") || previewImg.startsWith("blob:")
        ? previewImg
        : `${process.env.REACT_APP_IMAGE_BASE_URL}/${previewImg}`;
  } else {
    previewImgUrl = previewImg?.map((file) => URL.createObjectURL(file));
  }

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div>
      <div className="hrz-wrapper" style={{ marginTop: "40px" }}>
        <TitleText className="subtitle-in-box">
          {title}
          {isRequired && <RequiredMark>*</RequiredMark>}
        </TitleText>
        {showExample && handleClickEx && (
          <div
            style={{
              fontFamily: "notoSans-medium",
              fontSize: "15px",
              color: "#1167ed",
              textDecorationLine: "underline",
              marginLeft: "198px",
              cursor: "pointer",
            }}
            onClick={handleClickEx}
          >
            예시
          </div>
        )}
      </div>

      {previewImg ? (
        <div
          className="addImageButton"
          style={{ marginTop: "14px", cursor: readOnly ? "default" : "pointer" }}
          onMouseEnter={() => {
            if (!readOnly) {
              setIsHovered(true);
            }
          }}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isHovered && !readOnly && (
            <ImageHoveredDiv onClick={handleClickUpload}>
              <IconImageHover />
            </ImageHoveredDiv>
          )}
          <img
            src={previewImgUrl}
            alt="previewImage"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "top",
              borderRadius: "inherit",
            }}
          />
        </div>
      ) : (
        <div
          className="addImageButton"
          style={{ marginTop: "14px", cursor: readOnly ? "default" : "pointer" }}
          onClick={() => {
            if (!readOnly) {
              handleClickUpload();
            }
          }}
        >
          <IconPlus width="40px" height="40px" stroke="#888888" />
        </div>
      )}

      <div style={{ display: "flex", marginTop: "8px" }}>
        <IconInfo width="20px" height="20px" fill="#888888" />
        <div className="text-for-notice" style={{ marginLeft: "4px" }}>
          {noticeText}
        </div>
      </div>
    </div>
  );
};

const TitleText = styled.div`
  position: relative;
  width: fit-content;
`;

const RequiredMark = styled.span`
  position: absolute;
  top: 0;
  right: -10px;
`;

const ImageHoveredDiv = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: inherit;
  cursor: pointer;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default AddImage;
